export default {"src":"/_next/static/image/public/images/ic_eye_hide.24eee210de4f5601ba812ebbd6b90822.svg","height":18,"width":18};